import dayjs from "dayjs";
import { Dayjs as DayjsType } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DEFAULT_TIMEZONE = "Asia/Singapore";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

// 导出一个配置好的 Day.js 实例
export type Dayjs = DayjsType;
export default dayjs;
